export const getUserPath = (userId: string, key: string) =>
  `protected/${userId}/${key}` as const;
